<div id="audience">
  <div class="audience-inner">
    <dl class="row">
      <ng-container *ngFor="let audienceRows of audienceData">
        <dt class="col-sm-4">
          {{ audienceRows.qualification_name }}
          <span class="hasAud" *ngIf="audienceRows.isQuotaSet">
            Has Quotas</span
          >
        </dt>
        <dd
          class="col-sm-8"
          *ngIf="
            !audienceRows.isRangeType &&
            audienceRows.qualification_name !== 'Location'
          "
        >
          <ng-container *ngIf="!audienceRows.isAllSet">
            <ng-container *ngIf="!audienceRows.label">
              <span *ngFor="let qualObj of audienceRows.data; let i = index"
                >{{ qualObj.name
                }}{{
                  i + 1 !== audienceRows.data.length ? ',&nbsp;' : ''
                }}</span
              >
            </ng-container>
            <ng-container *ngIf="audienceRows.label">
              <span>{{ audienceRows.label }}</span>
            </ng-container>
          </ng-container>
          <span *ngIf="audienceRows.isAllSet">All</span>
        </dd>
        <dd
          class="col-sm-8"
          *ngIf="
            audienceRows.isRangeType &&
            audienceRows.qualification_name !== 'Location'
          "
        >
          <span *ngFor="let rangeQualObj of audienceRows.data">
            {{
              rangeQualObj.mn
                | currencySymbol
                  : rangeQualObj.units
                  : audienceRows.qualification_code
            }}&nbsp;-&nbsp;
            {{
              rangeQualObj.mx
                | currencySymbol
                  : rangeQualObj.units
                  : audienceRows.qualification_code
            }}<br />
          </span>
        </dd>
        <dd
          class="col-sm-8"
          *ngIf="audienceRows.qualification_name === 'Location'"
        >
          <ng-container
            *ngIf="audienceRows.data.length === 0 && audienceRows.isAllSet"
          >
            All
          </ng-container>

          <ng-container
            *ngIf="
              audienceRows.data.length > 0 &&
              !CSV_QUALIFICATION_CODES[audienceRows.qualification_code]
            "
          >
            <span [textContent]="audienceRows.key | titlecase"></span>
            <span *ngIf="audienceRows.data.length > 1">&nbsp;(s)</span>
            <span>&nbsp;-&nbsp;</span>
            <span
              *ngFor="
                let regionAudQuotas of audienceRows.data;
                let $last = last
              "
            >
              {{ regionAudQuotas.name }} {{ $last ? '' : ',&nbsp;' }}
            </span>
          </ng-container>
          <ng-container
            *ngIf="CSV_QUALIFICATION_CODES[audienceRows.qualification_code]"
          >
            <span [textContent]="audienceRows.key | titlecase"></span>
            <span>&nbsp;-&nbsp;</span>
            <button
              (click)="downloadCsv(audienceRows, surveyId)"
              style="font-size: 10px; background: #4a91c5; border: none"
              class="btn btn-primary"
            >
              View {{ audienceRows.key | titlecase }}
            </button>
          </ng-container>
        </dd>
      </ng-container>
    </dl>
  </div>
</div>
